// extracted by mini-css-extract-plugin
export default {"toggle":"Toggle_toggle__j503V"};